export default "__VITE_ASSET__14d2ccb2__"